import { useI18n } from "@/lib/i18n";

const Leaf = () => (
  <svg viewBox="0 0 24 24" className="mx-8 h-4 w-4 shrink-0 text-accent2" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
    <path d="M12 2C7 6 5 10 5 14a7 7 0 0 0 14 0c0-4-2-8-7-12z" /><path d="M12 6v15" />
  </svg>
);

export const Marquee = () => {
  const { t } = useI18n();
  const items = t("mq");
  const list = Array.isArray(items) ? items : [];
  const row = (k) => (
    <div key={k} className="flex shrink-0 items-center" aria-hidden={k === 1}>
      {list.map((it, i) => (
        <span key={i} className="flex items-center">
          <span className="whitespace-nowrap font-display text-3xl italic sm:text-5xl">{it}</span>
          <Leaf />
        </span>
      ))}
    </div>
  );
  return (
    <section data-testid="editorial-marquee" className="overflow-hidden border-y border-ink/10 bg-paper2 py-7 text-ink">
      <div className="flex w-max animate-marquee">{[0, 1].map(row)}</div>
    </section>
  );
};
